import React from 'react';
import styled from 'styled-components';
import { FaShieldAlt, FaCheckCircle, FaChartBar, FaLock } from 'react-icons/fa';
import SectionTitle from '../common/SectionTitle';
import { theme } from '../../styles/GlobalStyles';

const SectionContainer = styled.section`
  padding: 5rem 0;
  background-color: ${theme.bg};
`;

const ContentContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1.5rem;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(440px, 1fr));
  gap: 1.25rem;
  @media (max-width: 960px) { grid-template-columns: 1fr; }
`;

const BenefitCard = styled.div`
  display: flex;
  align-items: flex-start;
  padding: 1.75rem;
  background: ${theme.cardBg};
  border: 1px solid ${theme.border};
  border-radius: 16px;
  backdrop-filter: blur(12px);
  box-shadow: ${theme.cardShadow};
  transition: all 0.3s ease;

  &:hover {
    background: ${theme.cardBgHover};
    border-color: rgba(97,93,255,0.3);
    transform: translateY(-4px);
    box-shadow: 0 12px 40px rgba(97,93,255,0.15), ${theme.cardShadow};
  }
`;

const IconContainer = styled.div`
  width: 52px; height: 52px;
  background: linear-gradient(135deg, rgba(97,93,255,0.2), rgba(61,217,235,0.1));
  border: 1px solid rgba(97,93,255,0.2);
  border-radius: 14px;
  display: flex; align-items: center; justify-content: center;
  margin-right: 1.25rem;
  color: #615DFF; font-size: 1.3rem; flex-shrink: 0;
  transition: all 0.3s ease;

  ${BenefitCard}:hover & { color: #3DD9EB; box-shadow: 0 0 20px rgba(97,93,255,0.3); }
`;

const BenefitTitle = styled.h3`font-size:1.05rem;margin-bottom:0.5rem;color:${theme.text};`;
const BenefitDescription = styled.p`font-size:0.875rem;color:${theme.textMuted};margin:0;line-height:1.65;`;

const benefits = [
  { icon:<FaShieldAlt />,   title:'Stop Counterfeiting Before it Starts',      desc:'Protect your brand with secure, tamper-proof authentication that prevents counterfeiting at its source.' },
  { icon:<FaCheckCircle />, title:'Protect Consumers with Authentic Products', desc:"Give your customers confidence they're purchasing genuine products, building trust and loyalty." },
  { icon:<FaChartBar />,    title:'Actionable Data for Smarter Decisions',     desc:'Gain valuable insights into verification patterns and consumer behaviour to optimise your strategy.' },
  { icon:<FaLock />,        title:'Secure, Scalable & Ready-to-Use',           desc:'Our enterprise-grade solution scales with your business and integrates seamlessly with existing systems.' },
];

const WhyTrustSection = () => (
  <SectionContainer id="whytrust">
    <ContentContainer>
      <SectionTitle>Why Brands Trust Prodseal</SectionTitle>
      <BenefitsGrid>
        {benefits.map((b) => (
          <BenefitCard key={b.title}>
            <IconContainer>{b.icon}</IconContainer>
            <div>
              <BenefitTitle>{b.title}</BenefitTitle>
              <BenefitDescription>{b.desc}</BenefitDescription>
            </div>
          </BenefitCard>
        ))}
      </BenefitsGrid>
    </ContentContainer>
  </SectionContainer>
);

export default WhyTrustSection;
